
import {ILoanProducts} from "loan-application/interface";
import {IProfile} from "StateInterface";

export enum EventName {
    BASIC_ELIGIBILITY = "Basic Eligibility",
    PROFILE_UPDATE = "PROFILE_UPDATE",
    PRODUCT_VIEWED = "Product Viewed",
}

export const updateEligibilityEvents = (profile: IProfile, eventName: string, type: string, isSuccess?: boolean) => {
   const eventData = {
       [EventName.BASIC_ELIGIBILITY]: {
           "PAN": profile.panNumber,
           "Date of birth": new Date(profile.dob),
           "Pincode": profile.addressPincode,
           "Employment Type": profile.financeBasicInfo.employmentType,
           "Salary Mode": profile.financeBasicInfo.salaryMode,
           "Net Monthly Income": profile.financeBasicInfo.netMonthlyIncome,
           "Total work experience": profile.workExperienceMonths,
           "Company Name": profile.currentEmployer,
           "SUCCESS": isSuccess,
       },
       [EventName.PROFILE_UPDATE]: {
           "Loan Eligibility": isSuccess,
       },
   };
};

export const updateProductViewEvent = (product: ILoanProducts) => {
    const eventData = {
        "Product Name": product.title,
        "Product ID": product.productType,
        "Category Name": "Loans",
    };
};
